import { Link, Typography, Box, Stack } from '@mui/material';
import { useAppDispatch, useForm } from '../../../../../hooks';
import { useState } from 'react';
import { translateErrorMessage, validateEmail } from '../../../../../utils/authHelpers';
import { AUTH_API } from '../../../../../api/amplify';
import { INCORRECT_EMAIL } from '../../../../../constants/validationErrorMessages';
import { CODE_SENT } from '../../../../../constants/authMessages';
import { showAlert } from '../../../../../store';
import { AlertType } from '../../../../../types/common';
import { FormButton, FormInput } from '../../../../UI';
import { setAuthForm, setCognitoUserEmail } from '../../../../../store/CognitoSlice';
import { AuthForm } from '../../../../../types/auth';

type ForgotPasswordData = {
  email: string;
};

const INIT_USER: ForgotPasswordData = {
  email: '',
};

export const ForgotPassword = () => {
  const dispatch = useAppDispatch();

  const { input, error, handleChange, submit, handlePressEnter, setError, resetForm } = useForm(
    INIT_USER,
    handleSubmit
  );

  const [isLoading, setIsLoading] = useState(false);

  async function handleSubmit() {
    try {
      if (!validateEmail(input.email)) {
        setError((prev) => ({
          ...prev,
          email: INCORRECT_EMAIL,
        }));
        return;
      }
      setIsLoading(true);

      const { email } = input;

      await AUTH_API.forgotPassword(email);
      dispatch(showAlert({ type: AlertType.Success, message: CODE_SENT }));

      dispatch(setAuthForm(AuthForm.ChangePassword));
      dispatch(setCognitoUserEmail(email));

      resetForm();
    } catch (e: any) {
      const errorMessage = translateErrorMessage(e);
      dispatch(showAlert({ type: AlertType.Error, message: errorMessage }));
    }
    setIsLoading(false);
  }

  const switchToSigninForm = () => {
    dispatch(setAuthForm(AuthForm.Signin));
  };

  return (
    <Stack
      sx={{
        width: '100%',
        maxWidth: '400px',
        margin: '0 auto',
        gap: '60px',
      }}
    >
      <Stack onKeyDown={handlePressEnter}>
        <Typography
          variant="h1"
          mb={'30px'}
          align={'center'}
          sx={{
            typography: {
              mobile: 'h3',
              laptop: 'h1',
            },
          }}
        >
          Забыли пароль?
        </Typography>

        <Stack gap={'20px'} component={'form'} onSubmit={submit}>
          <Box>
            <FormInput
              onChange={handleChange}
              error={error?.email || ''}
              name={'email'}
              value={input.email || ''}
              placeholder={'Email'}
              label={'Email'}
              smallLabel
            />
          </Box>
          <Stack gap={'20px'}>
            <FormButton isLoading={isLoading} submit>
              Отправить код на почту
            </FormButton>

            <Link component={'button'} onClick={switchToSigninForm} underline={'none'} type={'button'}>
              Войти
            </Link>
          </Stack>
        </Stack>
      </Stack>
    </Stack>
  );
};
